export const interactive = "interactive";
export const live = "live";
export const recorded = "recorded";
export const video = "video";



// WEBPACK FOOTER //
// ./src/constants/courseTypes.js